
import React, { useState } from "react";
import { Terrace } from "@/types/terrace";
import { useMapboxToken } from "@/hooks/useMapboxToken";
import MapContainer from "@/components/map/MapContainer";
import MapLoadingState from "@/components/map/MapLoadingState";
import MapErrorState from "@/components/map/MapErrorState";

type MapboxMapProps = {
  terraces: Terrace[];
  userLocation?: { lat: number; lng: number } | null;
  onMapClick?: () => void;
  interactive?: boolean; // New prop to control interactivity
};

const MapboxMap: React.FC<MapboxMapProps> = ({ 
  terraces, 
  userLocation, 
  onMapClick,
  interactive = true // Default to interactive
}) => {
  const { mapboxToken, loadingToken, tokenError } = useMapboxToken();
  const [mapError, setMapError] = useState<string | null>(null);

  const handleMapError = (error: string) => {
    setMapError(error);
  };

  const handleRetry = () => {
    window.location.reload();
  };

  // Render loading state
  if (loadingToken) {
    return <MapLoadingState />;
  }

  // Render error state
  if (tokenError || mapError) {
    return <MapErrorState error={tokenError || mapError || "Unknown error"} onRetry={handleRetry} />;
  }

  // Render map container
  if (!mapboxToken) {
    return <MapErrorState error="No Mapbox token available" onRetry={handleRetry} />;
  }

  return (
    <MapContainer
      terraces={terraces}
      userLocation={userLocation}
      mapboxToken={mapboxToken}
      onMapError={handleMapError}
      onMapClick={onMapClick}
      interactive={interactive}
    />
  );
};

export default MapboxMap;
